import * as React from 'react';
import classnames from 'classnames';
import moment from 'moment-timezone';
import FontAwesomeIcon from 'react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { HubConnectionState } from '@microsoft/signalr';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { Store } from './types';
import { fetchData } from './actions/Actions';
import { CLOUDINARY_BASE_URL } from './Constants';

const Footer: React.FC = () => {
    const connection = useSelector(({ app }: Store) => app.connection);
    const { fullName, userName } = useSelector(({ app }: Store) => app.user);
    const dispatch: ThunkDispatch<Store, unknown, AnyAction> = useDispatch();

    const [connectionState, setConnectionState] = React.useState<HubConnectionState>(
        connection.state
    );
    const [connectionBlinking, setConnectionBlinking] = React.useState(
        connection.state !== HubConnectionState.Connected
    );

    React.useEffect(() => {
        connection.onclose(() => {
            setConnectionState(connection.state);
            setConnectionBlinking(connection.state !== HubConnectionState.Connected);
        });
        connection.onreconnected(() => {
            setConnectionState(connection.state);
            setConnectionBlinking(connection.state !== HubConnectionState.Connected);
        });
        connection.onreconnecting(() => {
            setConnectionState(connection.state);
            setConnectionBlinking(connection.state !== HubConnectionState.Connected);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleConnectionRefresh = React.useCallback(async () => {
        await connection.stop();

        await dispatch(fetchData());

        connection.start().then(() => {
            setConnectionState(connection.state);
            setConnectionBlinking(connection.state !== HubConnectionState.Connected);
        });
    }, [connection, dispatch]);

    return (
        <div className='app-footer'>
            <div className='user footer-item'>
                LOGGED USER {fullName} ({userName})
            </div>
            <div className='version footer-item'>VERSION 0.0.1-2021</div>
            <div className='current-time footer-item'>
                {moment().format('DD-MM-YYYY')}
            </div>
            <div className='actions footer-item'>
                <FontAwesomeIcon
                    name='repeat'
                    className='refresh action-icon'
                    onClick={handleConnectionRefresh}
                />
                <img
                    className={classnames('connection-state action-icon', {
                        blink: connectionBlinking
                    })}
                    src={`${CLOUDINARY_BASE_URL}/generic/icons/${
                        connectionState === HubConnectionState.Connected
                            ? 'signalr_on'
                            : 'signalr_off'
                    }`}
                />
            </div>
        </div>
    );
};

export default Footer;
